import { Calculator, Database, Image, Target } from 'lucide-react';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

interface Tool {
  id: string;
  name: string;
  path: string;
  icon: React.ReactNode;
}

const tools: Tool[] = [
  {
    id: 'dbf-viewer',
    name: 'DBF Viewer',
    path: '/dbf',
    icon: <Database size={40} />,
  },
  {
    id: 'goal-planner',
    name: 'Goal Planner',
    path: '/goalplanner',
    icon: <Target size={40} />,
  },
  {
    id: 'status-image-creator',
    name: 'Status Image Creator',
    path: '/status',
    icon: <Image size={40} />,
  },
  {
    id: 'textcalci',
    name: 'TextCalci',
    path: '/textcalci',
    icon: <Calculator size={40} />,
  },
].sort((a, b) => a.name.localeCompare(b.name));

const Home: React.FC = () => {
  useEffect(() => {
    document.title = 'Misc Tools | NiveshRight';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-8">
      <div className="max-w-5xl w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map(tool => (
            <Link key={tool.id} to={tool.path}>
              <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 text-center group cursor-pointer">
                <div className="flex justify-center mb-4 text-blue-600 group-hover:scale-110 transition-transform">
                  {tool.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {tool.name}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
